"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationGuardProvider = exports.useNavigationGuard = void 0;
var useNavigationGuard_1 = require("./hooks/useNavigationGuard");
Object.defineProperty(exports, "useNavigationGuard", { enumerable: true, get: function () { return useNavigationGuard_1.useNavigationGuard; } });
var NavigationGuardProvider_1 = require("./components/NavigationGuardProvider");
Object.defineProperty(exports, "NavigationGuardProvider", { enumerable: true, get: function () { return NavigationGuardProvider_1.NavigationGuardProvider; } });
